import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const supportUsersAdapter = createEntityAdapter({})

const initialState = supportUsersAdapter.getInitialState()

export const supportUsersApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSupportUsers: builder.query({
            query: () => ({
                url: '/supportusers',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedUsers = responseData.map(supportuser => {
                    supportuser.id = supportuser._id
                    return supportuser
                });
                return supportUsersAdapter.setAll(initialState, loadedUsers)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'SupportUser', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'SupportUser', id }))
                    ]
                } else return [{ type: 'SupportUser', id: 'LIST' }]
            }
        }),
        addNewSupportUser: builder.mutation({
            query: initialUserData => ({
                url: '/supportusers',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'SupportUser', id: "LIST" }
            ]
        }),       
        updateSupportUser: builder.mutation({
            query: initialUserData => ({
                url: '/supportusers',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SupportUser', id: arg.id }
            ]
        }),
        updateArraySupportUser: builder.mutation({
            query: initialUserData => ({
                url: '/supportusers/addinsubarray',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SupportUser', id: arg.id }
            ]
        }),
        deleteSupportUser: builder.mutation({
            query: ({ id }) => ({
                url: `/supportusers`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'SupportUser', id: arg.id }
            ]
        }),       
    }),
})

export const {    
    useGetSupportUsersQuery,
    useAddNewSupportUserMutation,
    useUpdateSupportUserMutation,
    useUpdateArraySupportUserMutation,
    useDeleteSupportUserMutation    
} = supportUsersApiSlice

// returns the query result object
export const selectSupportUsersResult = supportUsersApiSlice.endpoints.getUsers.select()

// creates memoized selector
const selectSupportUsersData = createSelector(
    selectSupportUsersResult,
    supportusersResult => supportusersResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllSupportUsers,
    selectById: selectSupportUserById,
    selectIds: selectSupportUserIds
    // Pass in a selector that returns the users slice of state
} = supportUsersAdapter.getSelectors(state => selectSupportUsersData(state) ?? initialState)